import type { IEditorQuery } from './../../../ricos-content-query';
import type { ModalService } from './../../../ricos-modals';
import type { IToolbarSettings, PublisherProvider, TiptapEditor } from './../../../ricos-types';
import { TOOLBARS } from './../../../editor-common';

import type { Topics } from '../../topics';
import type { ToolbarServices } from '../../types';
import { RicosToolbar } from '../ricos-toolbar';

export class PluginMenuToolbar extends RicosToolbar<TOOLBARS.SIDE> {
  constructor(
    isMobile: boolean,
    services: ToolbarServices,
    publishers: PublisherProvider<Topics>,
    settings: IToolbarSettings<TOOLBARS.SIDE>,
    shouldCreate: boolean
  ) {
    super(isMobile, services, TOOLBARS.SIDE, publishers, settings);
    this.isEmpty = () => !shouldCreate;
    services.plugins
      .getAddButtons()
      .registerPluginMenuModal(
        settings?.name === TOOLBARS.SIDE ? settings?.addPluginMenuConfig : {}
      );
  }

  public getVisibleFloatingButtonComponent(args: {
    editorQuery: IEditorQuery['query'];
    modalService: ModalService;
    editor: TiptapEditor;
    nodeId?: string;
  }) {
    return (
      this.services.plugins.getFloatingToolbarButtons().find(button => button.isVisible(args))
        ?.Component ?? undefined
    );
  }
}
